import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { LeaderboardView } from "@/features/courses/components/leaderboard/leaderboard-view";

export const leaderboardRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/leaderboard",
  component: LeaderboardView,
});
